var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnKid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    viewBox: "0 0 15 13",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .072h14.929v11.384h-14.929z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c2c2c",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.237 8.559c-.654-.326-1.219-.714-1.707-1.213-.91-.93-1.424-2.036-1.394-3.38.01-.419.01-.838-.004-1.256-.03-.9-.713-1.597-1.59-1.632-.342-.014-.554-.22-.541-.53.012-.298.232-.481.569-.476 1.334.022 2.485 1.171 2.54 2.544.016.411.008.824.011 1.236v.238h11.381c.066 0 .132-.001.197.002.157.006.24.077.23.254-.039.585-.17 1.145-.433 1.668-.539 1.076-1.365 1.85-2.398 2.406l-.26.143c.569.096.975.37 1.196.882.159.368.16.748.008 1.122-.312.765-1.204 1.108-1.926.742-.818-.414-.99-1.278-.43-2.311-1.444.398-2.865.402-4.306-.002.483.899.467 1.474-.035 2.027-.38.417-1.065.553-1.584.314-.526-.242-.895-.854-.838-1.39.083-.775.477-1.203 1.314-1.388",
    mask: "url(#a)",
    transform: "translate(0 1.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.748 4.779h-2.874c-.296 0-.365-.112-.239-.385l1.929-4.159c.119-.257.162-.277.426-.185 1.26.437 2.343 1.139 3.135 2.26.452.64.711 1.361.796 2.148.026.244-.04.32-.279.32h-2.894"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnKid);
export default __webpack_public_path__ + "static/media/icn_kid.cd5e4160d62704aa559727c2ff08e56b.svg";
export { ForwardRef as ReactComponent };